export default "__VITE_ASSET__CRnRCi51__"